export default __webpack_public_path__ + "b9e029919ad143d40256240873169b1e.png";